import { RoutePath } from 'applications/GSP/shared/constants/router';

export const PAGES_THRESHOLD = 2;

export const ObservedRoutes = [
  RoutePath.Dashboard,
  RoutePath.Progress,
  RoutePath.ProgressSubject,
  RoutePath.SubjectOverview,
];
